import {
  mapper
} from '@shared/lib';
import {
  type GameWinnersState
} from '../model';
import {
  mapGameWinner
} from './map-game-winner';

type MapGameWinners = (data: any) => Pick<GameWinnersState, 'winners'>;
export const mapGameWinners: MapGameWinners = mapper([
  { name: 'winners', from: 'data', transform: (data: Array<any>) => data.map(mapGameWinner) },
]);
